import { AppState } from '../../types';

export const selectRegistrationForm = (state: AppState) => state.register.form;
export const selectRegister = (state: AppState) => state.register.register;
export const selectResend = (state: AppState) => state.register.resend;
